import React, { useMemo } from 'react';
import Loading from '@intelligence/components/Loading';
import { financeFormat } from '@/pages/home/utils/common';
import SvgIcon from '@/pages/home/components/SvgIcon';
import { useIntl, getLocale } from 'umi';
import './index.scss';
import AggregationBubble from '@/pages/intelligence/components/AggregationBubble';
import SteamLineHooks from './_hooks';
// import { LANGUAGE_CN } from '@/pages/home/_config/config';
// import useIntlExtend from '@/pages/intelligence/hooks/useIntlExtend';

export default function SteamLineReviews({
  steamDateType = 'day',
  gameId = '',
  showReviewTotal = true,
  combineGameIdList,
}: any) {
  const idList = useMemo(() => {
    return combineGameIdList.filter((game: any) => game.entity_type == 'pc');
  }, [combineGameIdList]);
  const { isLoading, steamLineList, isEmpty, reviewName } = SteamLineHooks({ steamDateType, gameId, idList });
  const { formatMessage } = useIntl();
  // const locale = getLocale();
  // const isCN = locale === LANGUAGE_CN;

  if (isLoading) return (
    <Loading
      style={{ height: 80, color: '#444' }}
      content={formatMessage({ id: 'common_loading' })}
    />
  );
  return (
    <>
      {isEmpty ? (
        <div className="context-nodata">
          {formatMessage({
            id: 'dbi_no_data_available',
          })}
        </div>
      ) : (
        <div className="dbi-steam-line-reviews-context">
          {showReviewTotal && (
            <div className="context-item-num-kpioverview">{formatMessage({ id: reviewName })}</div>
          )}
          {steamLineList.map(({ color, text, width, value, icon }: any) => (
            <div className="context-item-goodNum" key={text}>
              <SvgIcon type={icon} className="context-item-goodNum-icon" />
              <AggregationBubble
                placement="top"
                DomOrText={
                  <div
                    className={`context-item-goodNum-desc ${
                      formatMessage({ id: text }) === 'Positive' ||
                      formatMessage({ id: text }) === 'Negative'
                        ? ''
                        : 'context-item-goodNum-small-width'
                    }`}
                  >
                    {formatMessage({ id: text })}
                  </div>
                }
                customBubbleContent={
                  <span className="context-item-goodNum-desc">{formatMessage({ id: text })}</span>
                }
              ></AggregationBubble>
              <div className="context-item-goodNum-line" style={{ width, background: color }} />
              <span className="context-item-goodNum-text">
                {financeFormat(value, 2, false, '-')} ({width})
              </span>
            </div>
          ))}
        </div>
      )}
    </>
  );
}
